import { FavoriteType } from '@kcftech/prometheustypescriptapiclient';
import { useUser } from 'contexts/UserContext';
import { showFavorite } from 'custom_hooks/data_hooks/favorites/useLocationFavorites';
import { useMemo } from 'react';

export type UseDashboardFavoritesProps = Readonly<{
    corporationId: string | undefined;
    locationId: string | undefined;
}>;

export function useDashboardFavorites({
    corporationId,
    locationId,
}: UseDashboardFavoritesProps) {
    const { favorites } = useUser();

    return useMemo(
        () =>
            favorites?.filter(
                (favorite) =>
                    favorite.FavoriteType.FavoriteTypeName ===
                        FavoriteType.PowerBiDashboard &&
                    showFavorite(favorite, corporationId, locationId)
            ) ?? [],
        [corporationId, favorites, locationId]
    );
}
